import ws from '../../ws';
import getToken from '../../redux/actions/getToken';

class UrlError extends Error {
  url = 'Страница с таким URL уже существует';
}

const asyncValidate = async (values) => {
  const token = getToken();
  const data = { url: values.url, token };
  data.id = Object.prototype.hasOwnProperty.call(values, 'id') ? values.id : null;

  return new Promise((resolve, reject) => {
    ws.emit('api/academy/pages/checkAsyncData', data, (result) => {
      const { status, payload } = result;

      if (status === 'ok' && payload) {
        reject(new UrlError());
      } else {
        resolve();
      }
    });
  });
};

export default asyncValidate;
